<template>
<q-page class="reset" :class="{'bg-white': !$isDesktop}">
  <div class="row justify-center items-center" :class="$isDesktop ? 'q-pa-xl' : 'q-pa-md'">
    <q-card v-if="$isDesktop" class="col-6">
      <div :class="{'q-mt-md q-mx-md': !$isMobile, 'q-pa-md': $isMobile}">
        <h1 class="heading-2 q-mb-lg text-primary">Activeer uw account</h1>
      </div>
      <common-form :action="$route('auth.store-first-login')">
        <q-card-section class="q-pa-lg">
          <div class="row q-col-gutter-x-md q-pb-lg">
            <div class="col-6">
              <common-input
                  v-model="personalForm.first_name"
                  label="Voornaam"
                  name="first_name"
                  autocomplete="given-name"
                  :error-message="$errorMessage('first_name')"
                  :error="$hasError('first_name')"
              />
            </div>
            <div class="col-6">
              <common-input
                  v-model="personalForm.last_name"
                  label="Achternaam"
                  name="last_name"
                  autocomplete="family-name"
                  :error-message="$errorMessage('last_name')"
                  :error="$hasError('last_name')"
              />
            </div>
          </div>
          <div class="row q-pb-lg">
            <div class="col-12">
              <common-input
                  v-model="personalForm.phone_number"
                  label="Telefoonnummer"
                  type="tel"
                  name="phone_number"
                  autocomplete="tel"
                  :error-message="$errorMessage('phone_number')"
                  :error="$hasError('phone_number')"
              />
            </div>
          </div>
          <reset-form :token="token" />
        </q-card-section>
        <q-separator />
        <q-card-actions align="between" class="q-py-md q-px-lg">
          <accent-button label="Activeer" type="submit" />
        </q-card-actions>
      </common-form>
    </q-card>
    <div v-else class="col-xs-12 col-sm-10 q-mt-lg">
      <h1 class="heading-2 q-mb-lg text-primary">Activeer uw account</h1>
      <common-form :action="$route('auth.store-first-login')">
        <div class="row q-col-gutter-x-md q-pb-lg">
          <div class="col-6">
            <common-input
                v-model="personalForm.first_name"
                label="Voornaam"
                name="first_name"
                autocomplete="given-name"
                :error-message="$errorMessage('first_name')"
                :error="$hasError('first_name')"
            />
          </div>
          <div class="col-6">
            <common-input
                v-model="personalForm.last_name"
                label="Achternaam"
                name="last_name"
                autocomplete="family-name"
                :error-message="$errorMessage('last_name')"
                :error="$hasError('last_name')"
            />
          </div>
        </div>
        <div class="row q-pb-lg">
          <div class="col-12">
            <common-input
                v-model="personalForm.phone_number"
                label="Telefoonnummer"
                type="tel"
                name="phone_number"
                autocomplete="tel"
                :error-message="$errorMessage('phone_number')"
                :error="$hasError('phone_number')"
            />
          </div>
        </div>
        <reset-form :token="token" />
        <q-separator />
        <div class="row justify-end q-mt-md">
          <accent-button label="Activeer" type="submit" />
        </div>
      </common-form>
    </div>
  </div>
</q-page>
</template>

<script>
import ResetForm from './form/Reset'

export default {
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  components: {
    ResetForm,
  },
  data () {
    return {
      personalForm: {
        first_name: this.$old('first_name'),
        last_name: this.$old('last_name'),
        phone_number: this.$old('phone_number'),
      },
    }
  },
}
</script>
